import { get } from "shared/data";

export const getPostHistoryReq = (wipKey) => {
    return get(`/logging/product-post-logs?finalQaTaskKey=${wipKey}`);
};
